// api.js
// api.js
const API_CONFIG = {
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    googleSearchApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY
};

// Debugowanie - dodaj to:
console.log('API Key being used:', process.env.REACT_APP_GOOGLE_MAPS_API_KEY);
console.log('Environment:', process.env.NODE_ENV);

export default API_CONFIG;